import { Empty, Flex } from "antd";
import { FC } from "react";
import { TaskSaleAdditional } from "tm-shared/types";
import { formatUAHNarrow, formatUAHStandard } from "tm-shared/utils";

import {
    InfoRowList,
    ProductCard,
    TaskViewModal,
} from "@/features/TaskView/components";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

interface SaleViewModalProps {
    task: TaskSaleAdditional;
    onClose: () => void;
}

export const SaleViewModal: FC<SaleViewModalProps> = ({ task, onClose }) => {
    const completedAt = task?.completedAt;
    const payload = task?.payload;

    if (!completedAt) return null;

    const orderId = task.context.orderId;

    const ignoreRemainings =
        payload?.ignoreRemainingsOrders?.[orderId] ?? false;

    const orderProducts = payload?.marketProducts?.[orderId] ?? [];
    const paymentForm = payload?.paymentForms?.[orderId] ?? "не вказана";

    const sum = orderProducts.reduce((acc, p) => acc + p.count * p.price, 0);

    const infoRows = [
        { label: "Тип оплати:", value: `Форма ${paymentForm}` },
        {
            label: "Ігнорувати залишки:",
            value: ignoreRemainings ? "Так" : "Ні",
        },
        { label: "Сума замовлення:", value: formatUAHStandard(sum) },
    ];

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <InfoRowList items={infoRows} />

                {orderProducts.length === 0 ? (
                    <Empty
                        description="Немає продуктів для відображення"
                        style={{ padding: "40px 0" }}
                    />
                ) : (
                    <Flex vertical gap={12}>
                        {orderProducts.map((p) => (
                            <ProductCard key={p.barcode} product={p}>
                                <Flex gap={8}>
                                    <SecondaryText>Замовлено:</SecondaryText>

                                    <PrimaryText
                                        fontWeight="500"
                                        fontSize={16}
                                        textColor="accent"
                                    >
                                        {p.count} шт.
                                    </PrimaryText>

                                    <PrimaryText style={{ marginLeft: "auto" }}>
                                        {formatUAHNarrow(p.price)} / шт
                                    </PrimaryText>
                                </Flex>

                                <Flex gap={8}>
                                    <SecondaryText>
                                        Разом за позицію:
                                    </SecondaryText>

                                    <PrimaryText
                                        fontWeight="500"
                                        textColor="accent"
                                        fontSize={16}
                                    >
                                        {formatUAHStandard(p.price * p.count)}
                                    </PrimaryText>
                                </Flex>
                            </ProductCard>
                        ))}
                    </Flex>
                )}
            </Flex>
        </TaskViewModal>
    );
};
